module.exports = __webpack_public_path__ + "img/elemental_guard_tower_small.686c2af3.png";